import { render, staticRenderFns } from "./BotaoAvisarClienteWhatsApp.vue?vue&type=template&id=531ab507&lang=pug"
import script from "./BotaoAvisarClienteWhatsApp.vue?vue&type=script&lang=js"
export * from "./BotaoAvisarClienteWhatsApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports